<select *ngIf="options$ | async; let options; else: loading" [formControl]="fuelTankId">
  <option [ngValue]="none"></option>
  <option *ngFor="let o of options" [ngValue]="o.value">{{ o.label }}</option>
</select>
<ng-template #loading> Loading things... </ng-template>
